import React, { Fragment, useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import { compose } from 'recompose'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Button from '../../../components/Button'
import LoginPagesWrapper from '../../../components/LoginPagesWrapper'
import VerifyPhoneNumber from '../../../components/VerifyPhoneNumber'
import LinkButton from '../../../components/LinkButton'
import Paper from '@material-ui/core/Paper'
import { withRouter } from 'react-router'
import { checkEmail, resetEmailStatus, signIn, resetTeamBackground, resetTeamLogo } from '../../../redux/actions'
import { Link } from 'react-router-dom'
import { connect, useDispatch } from 'react-redux'
import FormTextField from '../../../components/FormTextField'
import { reduxForm, change, formValueSelector } from 'redux-form'
import { emailStatusSelector, emailValidationInProgressSelector, verifyPhoneMaskSelector } from '../../../redux/selectors'
import { required, passwordMatch, passwordStrength, email } from '../../../utilties/validators'
import Logo from '../../../assets/logo'
import { injectIntl } from 'react-intl'
import queryString from 'query-string'
import clsx from 'clsx'
import { FormHelperText, InputAdornment, CircularProgress } from '@material-ui/core'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'
import FormPassword from '../../../components/FormPassword'

const useStyles = makeStyles((theme) => ({
	gridStyle: {
	  padding: '4rem',
	  maxWidth: '479px',
	  width: '90%',
	  margin: '0 auto',
	  boxSizing: 'border-box',
	  display: 'flex',
	  flexDirection: 'column',
	  alignItems: 'center',
	  [theme.breakpoints.down('sm')]: {
		padding: '3rem 2rem',
	  }
	},	
	emailValidationNotRegistered: {
	  color: theme.palette.text.primary,
	  display: 'inline',
	},
	emailValidationGoToRegistration: {
		display: 'inline-block',
	},
	emailValidationNotFound: {
		color: theme.palette.error.main,
	}
  }));

const requiredValidator = required
const emailValidator = email
const passwordStrengthValidator = passwordStrength
const selector = formValueSelector('login')

const Login = ({ handleSubmit, intl, location, login, changeEmail, resetTeam, verifyPhoneMask, checkEmail, emailStatus, resetEmailStatus, currentEmail, emailValidationInProgress }) => {
	const classes = useStyles()
	const [returnPath, setReturnPath] = useState(null)
    const [rememberMe, setRememberMe] = React.useState(true);

	const dispatch = useDispatch()

    const [authRequest, setAuthRequest] = useState(() => () => { })

	const onSubmitForm = (values) => {
        setAuthRequest(() => () => login(values.email, values.password, rememberMe, returnPath, intl.locale))
		login(values.email, values.password, rememberMe, returnPath, intl.locale)
	}

    const handleChange = event => {
        setRememberMe(event.target.checked);
    };

	useEffect(
		() => {
			resetEmailStatus()
			resetTeam()
		}, []
	)

	useEffect(() => {
		const values = queryString.parse(location.search)

		if (values.returnUrl) {
			setReturnPath(values.returnUrl)
		}

		if (values.email) {
			changeEmail(values.email)
		}
		}, [])

	return (
		<LoginPagesWrapper
			hideMenu={true}
		>
			{
				verifyPhoneMask
					?
					<div style={{ display: 'flex', justifyContent: 'center', width: '90%', margin: '10vh auto 4rem' }}>
						<Paper style={{ maxWidth: '479px', width: '100%', margin: '0 auto' }} elevation={2}>
                            <VerifyPhoneNumber mode="verify-sign-in" returnUrl={returnPath} resendHandler={authRequest} />
						</Paper>
					</div>
					:
					<form onSubmit={handleSubmit(onSubmitForm)}
						data-testid='form-login'
						style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', margin: '10vh auto 0', paddingBottom: '10vh' }}>
						<Paper className={classes.gridStyle} elevation={2}>
							<Grid item style={{ paddingBottom: '20px', textAlign: 'center' }}>
								<Logo />
							</Grid>
							<Grid item style={{ paddingBottom: '20px', textAlign: 'center' }}>
								<Typography variant="subtitle2">{intl.formatMessage({ id: 'app.login.title' })}</Typography>
							</Grid>
							<Grid item style={{ width: '100%' }}>
								<FormTextField
									data-testid='form-login-input-email'
									label={intl.formatMessage({ id: 'app.email' })}
									fullWidth
									type='text'
									name='email'
									validators={[requiredValidator, emailValidator]}
									variant='filled'
									color='primary'
									onBlur={e => {if(e.target.value) checkEmail(e.target.value)}}
									onChange={() => {if(emailStatus != null) resetEmailStatus()}}
									inputProps={{
										endAdornment:
											emailStatus === 0
												? <InputAdornment position="end" style={{paddingRight: '11px'}}>
													<CheckCircleOutlineIcon style={{ color: 'green', fontSize: '28px' }} />
												</InputAdornment>
												: emailValidationInProgress
													? <CircularProgress size={20} style={{paddingRight: '11px'}}/>
													: null
									}}
									customInvalid={emailStatus > 0}
								/>
								{emailStatus > 0 && (
									<FormHelperText
										error={true}
										data-testid="auth-email-validation-error"
										style={{
											marginTop: '-22px',
											marginBottom: '18px',
										}}>
										{emailStatus === 1 && (
											<Fragment>
												<Typography variant="body2" className={classes.emailValidationNotRegistered}>
													{intl.formatMessage({ id: 'app.auth.emailValidationNotRegistered' })}
												</Typography>
												<Link className={classes.emailValidationGoToRegistration} to={`/auth/register?email=${encodeURIComponent(currentEmail)}`} style={{ textDecoration: 'none' }}>
													{intl.formatMessage({ id: 'app.auth.emailValidationGoToRegistration' })}
												</Link>
											</Fragment>)}
										{emailStatus === 2 && (
											<Typography variant="body2" className={classes.emailValidationNotFound}>
												{intl.formatMessage({ id: 'app.auth.emailValidationNotFound' })}
											</Typography>
										)}
									{
										emailStatus === 6
										&& <Fragment>
											<Typography variant="body2" className={classes.emailValidationNotRegistered}>
												{intl.formatMessage({ id: 'app.auth.emailValidationEmailChanged' })}
											</Typography>
											<Link className={classes.emailValidationGoToRegistration} to={`/auth/confirmpassword?email=${encodeURIComponent(currentEmail)}`}>
												{intl.formatMessage({ id: 'app.auth.emailValidationGoToSetupPassword' })}
											</Link>
										</Fragment>
									}
									</FormHelperText>
								)}
							</Grid>
							<Grid item style={{ width: '100%' }}>
								<FormPassword
									data-testid='form-login-input-password'
									label={intl.formatMessage({ id: 'app.password' })}
									fullWidth
									name='password'
									validators={[requiredValidator, passwordStrengthValidator]}
									variant='filled'
									color='primary'
								/>
							</Grid>
							<Grid item style={{ minWidth: '100%', marginTop: '5px' }}>
								<LinkButton
									data-testid='form-login-forgot-link'
									textId='app.login.forgotPasswordButtonText'
									variant='contained'
									color='primary'
									path={`/auth/forgotpassword?email=${currentEmail ? encodeURIComponent(currentEmail) : ''}`}
								/>
							</Grid>
							<Grid item style={{ minWidth: '100%', margin: '30px 0 20px' }}>
								<FormControlLabel style={{ marginLeft: '0' }}
									control={
										<Checkbox
											data-testid='form-login-checkbox-remember'
											color="primary"
											onChange={handleChange}
											checked={rememberMe}
										/>
									}
									label={
										<Grid item>
											<div style={{ color: '#000', 'fontSize': '15px' }}>
												{intl.formatMessage({ id: 'app.keepMeSignedIn.label' })}
											</div>
											<div style={{ color: '#000', 'fontSize': '15px' }}>
												{intl.formatMessage({ id: 'app.keepMeSignedIn.message' })}
											</div>
										</Grid>
									}
								/>
							</Grid>

							<Grid item style={{ paddingTop: '20px', textAlign: 'center' }}>
								<Button
									textId='app.login.buttonText'
									variant='contained'
									color='primary'
									size='large'
									type='submit'
									data-testid='form-login-button-login'
								/>
							</Grid>
						</Paper>
					</form>
			}
		</LoginPagesWrapper>
	)
}

const mapStateToProps = (state, ownProps) => ({
	failed: state.auth.failedLogin,
    verifyPhoneMask: verifyPhoneMaskSelector(state),
	emailStatus: emailStatusSelector(state),
	emailValidationInProgress: emailValidationInProgressSelector(state),
	currentEmail: selector(state, 'email')
})

const mapDispatchToProps = (dispatch, ownProps) => ({
	changeEmail: (email) => dispatch(change('login', 'email', email)),
	resetTeam: () => {
		dispatch(resetTeamBackground())
		dispatch(resetTeamLogo())
	},
	login: (email, password, rememberMe, returnUrl, language) => dispatch(signIn(email, password, rememberMe, returnUrl, language)),
	checkEmail: (email) => dispatch(checkEmail(email)),
	resetEmailStatus: () => dispatch(resetEmailStatus())
})

const enhance = compose(
	connect(mapStateToProps, mapDispatchToProps),
	injectIntl,
	reduxForm({
		form: 'login'
	}),
	withRouter
)

export default enhance(Login)
